import { render, staticRenderFns } from "./ReviewGeneralInfo.vue?vue&type=template&id=27a62d92&"
import script from "./ReviewGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./ReviewGeneralInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports